import React, { Component } from "react";
import {Card, Form, Button, Row, Col, Alert, Tab, Tabs} from "react-bootstrap";
import api from "../../services/api";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { papeisAssinatura, modelosDeMensagem } from '../../common/utils';
import { withRouter } from '../../common/with-router';
import AsyncSelect from 'react-select/async';
import {FaCheck, FaEye } from "react-icons/fa";

import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'

class ModelosMensagemEdit extends Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);

        this.enviaRegistro = this.enviaRegistro.bind(this);

        this.fileInput = React.createRef();

        this.state = {
            titulo: '',
            destinatario: '',
            conteudo: '',
            tipo_modelo: '',
            tipoHelper: '',
            tituloHelper: '',
            conteudoHelper: '',
            destinatarioHelper: '',
            erroLoadRegistro: "",
            modelo_id: "",
            titulo_pagina: "",
            loading: false,
        };
    }

    componentDidMount(){
        const id = this.props.router.params.id;

        if(id){
            this.setState({
                modelo_id: id,
                titulo_pagina: 'Editando Modelo de Mensagem',
                loading: true,
                erroLoadRegistro: ''
            })

            //consulta os dados do programa na api
            api.get(`/configuracoes/modelos-mensagem/${id}`)
            .then(response => {
                const dados = response.data;

                //preenche os inputs
                this.setState({
                    erroLoadRegistro: '',
                    titulo: dados.titulo,
                    destinatario: dados.destinatario,
                    tipo_modelo: dados.tipo_modelo,
                    conteudo: dados.conteudo,
                    loading: false
                })
            })
            .catch(error => {
                let erro_msg = 'Erro ao consultar o modelo de mensagem, tente novamente';

                if(error.response && error.response.status === 500){
                    erro_msg = 'Servidor indisponível no momento, tente novamente';
                }

                this.setState({
                    erroLoadRegistro: erro_msg,
                })
            });
        }
        else {
            this.setState({
                modelo_id: '',
                titulo_pagina: 'Adicionar Modelo de Mensagem',
                loading: false,
                erroLoadRegistro: '',
            })
        }
    }

    enviaRegistro = (e) => {
        e.preventDefault();

        const formData = new FormData();

        this.setState({
            loading: true,
            tipoHelper: "",
            destinatarioHelper: "",
            tituloHelper: "",
            nomeHelper: "",
            cidIdHelper: ""
        });

        //vererifica se é edição ou adição
        const url = (this.state.modelo_id) ? '/configuracoes/modelos-mensagem/'+this.state.modelo_id+'/' : '/configuracoes/modelos-mensagem/'
        const metodo = (this.state.modelo_id) ? 'put' : 'post'

        formData.append('titulo', this.state.titulo);
        formData.append('conteudo', this.state.conteudo);
        formData.append('destinatario', this.state.destinatario);
        formData.append('tipo_modelo', this.state.tipo_modelo);
        

        //envia para api
        api({
            method: metodo,
            url: url,
            data: formData,
        })
        .then(response => {
            const MySwal = withReactContent(Swal)
            const textSwal = (this.state.modelo_id) ? 'Modelo de mensagem atualizado com sucesso' : 'Modelo de mensagem cadastrado com sucesso';

            MySwal.fire({
                title: 'Sucesso!',
                html: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            })
            
            this.setState({
                loading: false,
            })
            
            //redireciona
            if(!this.state.modelo_id){
                this.props.router.navigate("/modelos-mensagem");
            }
        })
        .catch(error => {
            let erro_msg = 'Erro ao cadastrar o modelo de mensagem, verifique os campos e tente novamente';            

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;                
                
                //percorre os campos com erro
                for (let key in campos){
                    var value = campos[key];

                    if(key === 'titulo'){
                        this.setState({ tituloHelper: value })
                    }
                    if(key === 'destinatario'){
                        this.setState({ destinatarioHelper: value })
                    }
                    if(key === 'tipo_modelo'){
                        this.setState({ tipoHelper: value })
                    }
                    if(key === 'conteudo'){
                        this.setState({ conteudoHelper: value })
                    }
                };
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
            })    
            
            this.setState({
                loading: false,
            })
        });
    };

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    };

    handleQuillChange = (value) => {
        this.setState({ conteudo: value });
    };

    render(){
        return (
            <div>
                <Row className="align-items-center">
                    <Col sm={6} lg={6}>
                        <h4 className="page-title">{this.state.titulo_pagina}</h4>
                    </Col>
                </Row>
                <Tabs defaultActiveKey="dadosModelo" id="tabs-modelo" className="aditus-tabs">
                    <Tab eventKey="dadosModelo" title="Dados do Modelo de Mensagem">
                        <Card className="cardDestaque">
                            <Card.Body>                    
                                <Form onSubmit={this.enviaRegistro}>
                                    <h4>Dados do Modelo de Mensagem</h4>
                                    <Row>
                                        <Col sm={12} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Título <span className="text-danger">*</span></Form.Label>
                                                <Form.Control type="text" name="titulo" required placeholder="Título do Modelo de Mensagem" value={this.state.titulo} onChange={this.handleChange} />    
                                                <Form.Text id="formTituloHelper" className="text-danger">{this.state.tituloHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={12} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Conteúdo <span className="text-danger">*</span></Form.Label>
                                                <ReactQuill
                                                    value={this.state.conteudo}
                                                    onChange={this.handleQuillChange}
                                                    modules={{
                                                        toolbar: [
                                                            [{ 'header': [1, 2, 3, false] }],
                                                            ['bold', 'italic', 'underline'],
                                                            ['link'],
                                                            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                                                            [{ 'align': [] }],
                                                        ],
                                                    }}
                                                    formats={[
                                                        'header',
                                                        'bold', 'italic', 'underline',
                                                        'link',
                                                        'list', 'bullet',
                                                        'align',
                                                    ]}
                                                    placeholder="Conteúdo do Modelo de Mensagem"
                                                    className="custom-textarea mb-5"
                                                />
                                                <Form.Text id="formConteudoHelper" className="text-danger">{this.state.conteudoHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Tipo do Modelo <span className="text-danger">*</span></Form.Label>
                                                <Form.Control as="select" name="tipo_modelo" value={this.state.tipo_modelo} required onChange={this.handleChange}>
                                                    <option value="">Selecione o tipo do Modelo de Mensagem</option>
                                                    {Object.entries(modelosDeMensagem).map(([sigla, nome]) => (
                                                        <option key={sigla} value={sigla}>{nome}</option>
                                                    ))}
                                                </Form.Control>
                                                <Form.Text id="formTipoHelper" className="text-danger">{this.state.tipoHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Destinatário <span className="text-danger">*</span></Form.Label>
                                                <Form.Control type="text" name="destinatario" required placeholder="Destinatário do Modelo de Mensagem" value={this.state.destinatario} onChange={this.handleChange} />    
                                                <Form.Text id="formDestinatarioHelper" className="text-danger">{this.state.destinatarioHelper}</Form.Text>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    {this.state.erroLoadRegistro ? 
                                    <Alert variant="warning">
                                        {this.state.erroLoadRegistro}
                                    </Alert> : ''
                                    }                                      
                                    <Button variant="success" type="submit" className="btn-submit mt-3" disabled={this.state.loading}>
                                        {this.state.loading ? (
                                            <span className="spinner-border spinner-border-sm"></span>
                                        ) : (
                                            <>
                                                <FaCheck className="me-1" /> Salvar
                                            </>
                                        )}
                                    </Button>
                                </Form> 
                            </Card.Body>                
                        </Card>
                    </Tab>
                </Tabs>
            </div>
        )
    }
}

export default withRouter(ModelosMensagemEdit);